import { v4 as uuid } from "uuid";

import { MarkerPlayer, MarkerType, StencilType } from "../types";

export interface CreateNewPlayerProps extends Partial<MarkerPlayer> {
  pos: MarkerPlayer["pos"];
  playerIdNumber: MarkerPlayer["playerIdNumber"];
}

export const createNewPlayer = (playerProps: CreateNewPlayerProps): MarkerPlayer => {
  return {
    id: uuid(),
    stencilType: StencilType.MARKER,
    markerType: MarkerType.PLAYER,
    movements: [],
    fill: false,
    possession: false,
    label: `${playerProps.playerIdNumber}`,
    ...playerProps,
  };
};
